import React from "react";
import { Navigate } from "react-router";
import { useAuthState } from "../../adapters/insights-agent/state/hooks/stateHooks.ts";

export interface AuthenticationGuardProps {
  children: React.ReactNode;
}

export const AuthenticationGuard: React.FC<AuthenticationGuardProps> = ({
  children,
}) => {
  const authState = useAuthState();

  if (authState === "loading") {
    return null;
  }

  if (authState === "authenticated") {
    return <>{children}</>;
  }

  // If not authenticated, always redirect to login page
  return <Navigate to="/login" replace />;
};
